import api from '@/api';
import { API_BASE_URL } from '..';
import { BillingCreateRequest, BillingCreateResponse } from './Billing.types';

const CONTROLLER_URL = `${API_BASE_URL}/invoices`;

export async function createBillingInvoice(obj: BillingCreateRequest) {
  const { invoiceId, ...values } = obj;

  const result = (await api.post(
    `${CONTROLLER_URL}/${invoiceId}/billings`,
    values,
    null,
  )) as unknown;

  return result as BillingCreateResponse;
}

export async function getBillingInvoiceId(
  invoiceId: number,
): Promise<BillingCreateResponse> {
  const result = (await api.get(
    `${CONTROLLER_URL}/${invoiceId}/billings`,
    null,
  )) as unknown;
  return result as BillingCreateResponse;
}

export async function updateBillingInvoice(
  obj: BillingCreateRequest,
): Promise<BillingCreateResponse> {
  const { invoiceId, ...values } = obj;

  const result = (await api.put(
    `${CONTROLLER_URL}/${invoiceId}/billings`,
    values,
    null,
  )) as unknown;
  return result as BillingCreateResponse;
}
